import dayjs from "dayjs";
import { supermemo } from "supermemo";



export function isDue(card:any){
	const dueDate= dayjs(card.dueDate);
	const now = dayjs(Date.now());
	return now> dueDate;
}
export function practice(flashcard:any, grade:any) {
  const { interval, repetition, efactor } = supermemo(flashcard, grade);
  const dueDate = dayjs(Date.now()).add(interval, 'day').toISOString();
 
  return { ...flashcard, interval, repetition, efactor, dueDate };
}
